/* import __COLOCATED_TEMPLATE__ from './prism-overflow-menu.hbs'; */
import Component from '@ember/component';
import { next } from '@ember/runloop';

/**
 * @class PrismOverflowMenu
 */
export default Component.extend({
  classNames: ['prism-overflow-menu'],
  /**
   * @argument showContent typically left unset, but set to true if you want the menu to open automatically
   */
  showContent: false,
  /**
   * @argument onOpen e.g. to send tracking info when the menu is opened
   */
  onOpen() {},
  /**
   * @argument onClose e.g. to send tracking info when the menu is closed
   */
  onClose() {},
  toggleMenu() {
    if (this.showContent) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  },
  openMenu() {
    // Open the menu in the next runloop so that the opening click event
    // hits all of the external click handlers first.
    next(() => {
      this.set('showContent', true);
    });
    this.onOpen();
  },
  closeMenu() {
    this.set('showContent', false);
    this.onClose();
  }
});